import { useState, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { englishRegex, numberRegex, specialCharRegex } from "util/commAction";
import JoinBtnWrap from "../../btnWrap";
import { useAuthContext } from "components/context/authContext";
import { useNavigate } from "react-router-dom";
import { useJoinContext } from "components/context/joinContext";
import "./pwd.scss";

export default function Password() {
  const { t } = useTranslation();
  const { viewPort } = useAuthContext();
  const navigate = useNavigate();

  const { joinInf, onJoinInf } = useJoinContext();

  const [lgnPwd, setLgnPwd] = useState(joinInf?.lgnPwd ?? "");

  const [valid, setValid] = useState({
    isEnCharValid: false,
    isNumCharValid: false,
    isSpecialCharValid: false,
    isRangeCharValid: false,
    isEquali: false,
  });

  const handleShowPwd = (e: MouseEvent<HTMLLabelElement>) => {
    const clss = e.currentTarget.className as string;
    const input = e.currentTarget.previousSibling as HTMLInputElement;

    if (clss === "on") {
      e.currentTarget.className = "";
      input.type = "password";
    }
    if (clss !== "on") {
      e.currentTarget.className = "on";
      input.type = "text";
    }
  };

  const handleNext = () => {
    onJoinInf({
      lgnPwd,
    });
    navigate("/join/inf");
    // setJoinInf({
    //   ...joinInf,
    //   lgnPwd,
    // });

    // setJoinStep(4);
    // localStorage.setItem("joinStep", 4 + "");

    // localStorage.setItem(
    //   "joinInf",
    //   JSON.stringify({
    //     ...joinInf,
    //     lgnPwd,
    //   })
    // );
  };

  const isAble = Object.values(valid).every((value) => value === true);

  return (
    <div className={"join" + " " + viewPort?.screen + " " + "min-h-[464px]"}>
      <form className="pwd">
        <input
          type={"password"}
          id="lgnPwd"
          placeholder={t("plchl_pss_cmm")}
          defaultValue={lgnPwd}
          maxLength={20}
          onChange={(e) => {
            const value = e.currentTarget.value;
            setValid({
              ...valid,
              isEnCharValid: englishRegex.test(value) ? true : false,
              isNumCharValid: numberRegex.test(value) ? true : false,
              isSpecialCharValid: specialCharRegex.test(value) ? true : false,
              isRangeCharValid:
                value.length >= 8 && value.length <= 20 ? true : false,
            });
            setLgnPwd(e.currentTarget.value);
          }}
        />
        <label htmlFor="lgnPwd" onClick={handleShowPwd} />
        <div className="flex gap-[12px] mt-[10px] mb-[1.5rem]">
          <h6 className={valid.isEnCharValid ? "on" : ""}>
            {" "}
            {t("txt_en_cmm")}
          </h6>
          <h6 className={valid.isNumCharValid ? "on" : ""}>
            {t("txt_num_cmm")}
          </h6>
          <h6 className={valid.isSpecialCharValid ? "on" : ""}>
            {t("txt_spc_cmm")}
          </h6>
          <h6 className={valid.isRangeCharValid ? "on" : ""}>
            8 ~ 20 {t("txt_lss_cmm")}
          </h6>
        </div>
        <div className="text-left">
          <input
            type={"password"}
            id="lgnPwdcheck"
            placeholder={t("plchl_pss_chk_cmm")}
            defaultValue={joinInf?.lgnPwd ?? ""}
            onChange={(e) => {
              const value = e.currentTarget.value;

              setValid({
                ...valid,
                isEquali: value === lgnPwd,
              });
            }}
          />
          <label htmlFor="lgnPwdCheck" onClick={handleShowPwd} />
          <h6 className={"mt-[10px]" + " " + (valid.isEquali ? "on" : "")}>
            {t("txt_pss_mtch_cmm")}
          </h6>
        </div>
      </form>
      <JoinBtnWrap disabled={!isAble} handleNext={handleNext} />
    </div>
  );
}
